"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirst = exports.shallowEqual = void 0;
var shallow_equal_1 = require("./shallow-equal");
Object.defineProperty(exports, "shallowEqual", { enumerable: true, get: function () { return shallow_equal_1.shallowEqual; } });
var capitalize_first_1 = require("./capitalize-first");
Object.defineProperty(exports, "capitalizeFirst", { enumerable: true, get: function () { return capitalize_first_1.capitalizeFirst; } });
